const socialFeed = {
  "heading": "See how our benefits connect you to more of what you love.",
  "tag": "Tag us at #ATTTHANKS"
}

module.exports = socialFeed;
